import { VitistsToday } from "../../../types/employeeSettings";
import { PreferrenceData } from "../../../types/ganttChart";
import labels from "../../../utils/labels";
import TrippleSwitch from "../../UI/input/TrippleSwitch";
import RowCell from "../../UI/table/RowCell";

const EmployeePreferencesRow = ({
  citizenName,
  continuityScore,
  visitsToday,
  preference,
}: {
  citizenName: string;
  continuityScore: number;
  visitsToday: VitistsToday;
  preference: PreferrenceData;
}) => {
  return (
    <li className="flex">
      <RowCell width={170}>
        <p>{citizenName}</p>
      </RowCell>

      <RowCell alignment="Middle">
        <p>{continuityScore}</p>
      </RowCell>

      <RowCell alignment="Middle">
        <p>{`${visitsToday.withSelectedEmployee} ${labels.outOf} ${visitsToday.total}`}</p>
      </RowCell>

      <RowCell alignment="Middle">
        <TrippleSwitch
          index={preference.idEmployee}
          status={preference.employeeFavorabilityCode}
          idEmployee={preference.idEmployee}
          idServiceClient={preference.idServiceClient}
        />
      </RowCell>
    </li>
  );
};

export default EmployeePreferencesRow;
